export default "__VITE_ASSET__BZOpwkoh__"